import { range } from 'ramda'
import { firstValueFrom } from 'rxjs'
import { connectPagination } from 'instantsearch.js/es/connectors'
import {
    PaginationConnectorParams,
    PaginationWidgetDescription,
} from 'instantsearch.js/es/connectors/pagination/connectPagination'
import { Renderer } from 'instantsearch.js/es/types'

import { ChangeDetectorRef, Component, forwardRef, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'

import { AlgoliaInstantsearchComponent } from '@app-domains/algolia/components/algolia-instantsearch.component'
import { AbstractInstantsearchWidgetComponent } from '@app-domains/algolia/abstract-instantsearch-widget.component'

@Component({
    selector: 'app-algolia-pagination-connector',
    templateUrl: './algolia-pagination-connector.component.html',
})
export class AlgoliaPaginationConnectorComponent extends AbstractInstantsearchWidgetComponent<
PaginationWidgetDescription,
PaginationConnectorParams
> implements OnInit, OnDestroy {

    public override readonly widgetName = 'Pagination'

    public pagesLength: number
    public currentPageIndex: number
    public selectablePages: string[]
    public currentPageControl = new FormControl<number>(0, {
        nonNullable: true,
    })

    private initialised: boolean

    constructor(
        @Inject(forwardRef(() => AlgoliaInstantsearchComponent))
        public instantSearchInstance: AlgoliaInstantsearchComponent,
        private router: Router,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
    ) {
        super()
    }

    private setUrlPart(pageIndex: number): void {
        const page = pageIndex + 1
        this.router.navigate(
            [],
            {
                relativeTo: this.route,
                queryParams: {
                    page: page === 1 ? undefined : page,
                },
                queryParamsHandling: 'merge', // remove to replace all query params by provided
            },
        )
    }

    public override ngOnInit(): void {
        this.createWidget(connectPagination, {})
        super.ngOnInit()
    }

    public pageChanged(page: number): void {
        this.state?.refine(page)
        this.setUrlPart(page)
    }

    public override updateState: Renderer<PaginationWidgetDescription['renderState'], PaginationConnectorParams> = (
        state,
        isFirstRendering,
    ): void => {
        if (isFirstRendering) {
            this.state = state
            this.initialiseRefinementFromUrl()
        } else {
            this.state = state
        }

        const results = state

        if (results && this.initialised) {
            this.pagesLength = results.nbPages
            this.selectablePages = range(1, results.nbPages + 1).map(String)
            this.currentPageIndex = results.currentRefinement
            this.cdr.detectChanges()
        }
    }

    private async initialiseRefinementFromUrl() {
        const queryParams = await firstValueFrom(this.route.queryParamMap)
        const page = parseInt(queryParams.get(
            'page',
        ) ?? '')

        if (page) {
            this.state?.refine(page - 1)
            this.currentPageControl.patchValue(page - 1)
        }

        this.initialised = true
        return !! page
    }
}
